import React, {useState} from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button, Form, Segment} from 'semantic-ui-react';

import {CreateBenchmarkDiscussionCommentComponent} from '../generated/graphql';
import {InlineMarkdownEditor} from './elements/InlineMarkdownEditor';

interface CreateDiscussionCommentFormProps {
  discussionThreadID: string;
  onSubmit: () => void;
}

const CreateDiscussionCommentForm: React.FC<CreateDiscussionCommentFormProps> =
  React.memo(({discussionThreadID, onSubmit}) => {
    const [body, setBody] = useState('');
    const [editorKey, setEditorKey] = useState(randomKey());

    return (
      <div className="discussion-board-create-comment">
        <CreateBenchmarkDiscussionCommentComponent>
          {createCommentMutation => {
            return (
              <Segment>
                <Form>
                  <Form.Field>
                    <InlineMarkdownEditor
                      key={editorKey}
                      placeholder="Contribute to the conversation"
                      readOnly={false}
                      onChange={value => {
                        setBody(value as string);
                      }}
                    />
                  </Form.Field>
                </Form>
                <Button
                  style={{marginTop: 5}}
                  disabled={body === ''}
                  onClick={() => {
                    createCommentMutation({
                      variables: {
                        discussionThreadID,
                        body,
                      },
                    })
                      .then(() => onSubmit())
                      .then(() => setEditorKey(randomKey()));
                  }}>
                  Comment
                </Button>
              </Segment>
            );
          }}
        </CreateBenchmarkDiscussionCommentComponent>
      </div>
    );
  });

export default CreateDiscussionCommentForm;

function randomKey(): string {
  return Math.random().toString(36);
}
